import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { WebSocketLink } from "apollo-link-ws";

/**
 * - Takes a headers object and generates/returns a new Apollo Client object.
 * @param {object} headers
 * @returns {ApolloClient}
 */
export const apolloClientFactory = headers => {
  // Create the subscription websocket link
  const link = new WebSocketLink({
    uri: process.env.VUE_APP_GRAPHQL_ENDPOINT,
    options: {
      lazy: true,
      reconnect: true,
      connectionParams: () => {
        return {
          headers: headers
        };
      }
    }
  });

  // Cache implementation
  const cache = new InMemoryCache();

  // Instantiate the new Apollo Client
  const apolloClient = new ApolloClient({
    link,
    cache
  });

  return apolloClient;
};

/**
 * Build headers object for the graphQL connection
 * @param {string} idToken
 * @param {string} teamId
 * @returns {object}
 */
export const headersBuilder = (idToken, teamId) => {
  let headers = {};
  idToken ? (headers.Authorization = `Bearer ${idToken}`) : false;
  teamId ? (headers["x-hasura-team-id"] = teamId) : false;
  return headers;
};
